import { css } from 'styled-components';

/**
 * A CSS utility changing icon color.
 *
 * @param fill - The desired color (hex, rgb/a, ..)
 */
export const iconFill = (fill: string) => css`
    &:not([fill]) {
        fill: ${fill};
    }

    & svg:not([fill]) {
        fill: ${fill};
    }
`;

/**
 * A CSS utility changing icon stroke color.
 *
 * @param stroke - The desired color (hex, rgb/a, ..)
 */
export const iconStroke = (stroke: string) => css`
    &:not([stroke]) {
        stroke: ${stroke};
    }

    & svg:not([stroke]) {
        stroke: ${stroke};
    }
`;

/**
 * A CSS utility for applying mediaQueries with predefined theme break points.
 * Helps keeping the code DRY and sticking to theme breakpoints.
 *
 * @param bp - The theme break point index. Or function returning custom break point.
 * @param innerCss - The style to be applied
 */
export const mediaQuery = (
    bp: 0 | 1 | 2 | 3 | 4 | (() => string),
    innerCss: ReturnType<typeof css>
) => css`
    @media (min-width: ${({ theme }) =>
            typeof bp === 'function' ? bp() : theme.breakPoints[bp]}) {
        ${innerCss}
    }
`;

/**
 * A CSS utility for applying mediaQueries with predefined theme break points.
 * Helps keeping the code DRY and sticking to theme breakpoints.
 *
 * @param bp - The theme break point index. Or function returning custom break point.
 * @param innerCss - The style to be applied
 */
export const mediaMaxQuery = (
    bp: 0 | 1 | 2 | 3 | 4 | (() => string),
    innerCss: ReturnType<typeof css>
) => css`
    @media (max-width: ${({ theme }) =>
            typeof bp === 'function' ? bp() : theme.breakPoints[bp]}) {
        ${innerCss}
    }
`;
